// extracted by mini-css-extract-plugin
export default {"fwrAuthHeader":"ChooseOffice_fwrAuthHeader__Do8Qy","fwrLogo":"ChooseOffice_fwrLogo__d0Sog"};